<template>
  <div class="audio-player-box">
    <div class="voice-info">
      <van-icon name="volume-o" size="16" color="#999" />
      <span class="voice-label">语音</span>
      <span class="duration">{{ formattedDuration }}</span>
    </div>
    <div class="play-action" @click="togglePlay">
      <van-icon :name="playing ? 'stop-circle-o' : 'play-circle-o'" size="26" color="#aa341b" />
    </div>
    <div v-if="showDelete" class="delete-action" @click.stop="$emit('delete')">
      <van-icon name="cross" size="16" color="#999" />
    </div>
  </div>
</template>

<script>
import {wecomSDK} from '@/utils/wecom';

export default {
  name: 'AudioPlayer',
  props: {
    localId: {
      type: String, // WeCom localId
      default: ''
    },
    src: {
      type: String, // Remote URL (S3)
      default: ''
    },
    duration: {
      type: [String, Number],
      default: ''
    },
    showDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      playing: false,
      audio: null
    };
  },
  computed: {
    formattedDuration() {
      if (!this.duration) return '15"';
      return typeof this.duration === 'string' && this.duration.includes('"')
        ? this.duration
        : `${this.duration}"`;
    }
  },
  beforeDestroy() {
    this.stopPlay();
  },
  methods: {
    togglePlay() {
      if (this.playing) {
        this.stopPlay();
      } else {
        this.playVoice();
      }
    },
    playVoice() {
      if (this.localId) {
        // WeCom playback
        wecomSDK.playVoice(this.localId);
        this.playing = true;

        // Listen to play end if possible, or use duration timeout
        let durationSec = parseFloat(this.duration) || 15;
        this.clearWecomTimer();
        this.wecomTimer = setTimeout(() => {
          this.playing = false;
        }, durationSec * 1000);
      } else if (this.src) {
        // HTML5 Audio
        if (!this.audio) {
          this.audio = new Audio(this.src);
          // When playing ends normally
          this.audio.onended = () => {
            this.playing = false;
            this.audio.currentTime = 0; // Reset to start
          };
          // On error or other stop
          this.audio.onpause = () => {
            this.playing = false;
          };
        }
        this.audio.currentTime = 0; // Always start from beginning if asked to play (Stop behavior)
        this.audio.play();
        this.playing = true;
      }
    },
    stopPlay() {
      if (this.localId) {
        wecomSDK.stopVoice(this.localId);
        this.playing = false;
        this.clearWecomTimer();
      } else if (this.audio) {
        this.audio.pause();
        this.audio.currentTime = 0; // Reset to start so next play is from beginning
        this.playing = false;
      }
    },
    clearWecomTimer() {
      if (this.wecomTimer) {
        clearTimeout(this.wecomTimer);
        this.wecomTimer = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.audio-player-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f2f5f9;
  border-radius: 18px;
  padding: 8px 12px;
  width: 100%;

  .voice-info {
    display: flex;
    align-items: center;
    flex: 1;

    .van-icon {
      margin-right: 6px;
    }

    .voice-label {
      font-size: 12px;
      color: #666;
      margin-right: 15px;
    }

    .duration {
      font-size: 15px;
      color: #999;
    }
  }

  .play-action {
    display: flex;
    align-items: center;
  }

  .delete-action {
    margin-left: 12px;
    display: flex;
    align-items: center;
    padding: 4px;
  }
}
</style>
